import { Container, CircularProgress } from "@mui/material";
import ItemList from "../../components/ItemList";
import { useEffect, useState } from "react";
import { getBackend } from "../../api/backend";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { fetchWithCache } from "../../utils/cacheUtils";

const Machines = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [machineTypes, setMachineTypes] = useState({});
  const [machineBrands, setMachineBrands] = useState({});
  const [machineTypeCharacteristics, setMachineTypeCharacteristics] = useState(
    {}
  );
  const [machineCharacteristics, setMachineCharacteristics] = useState({});
  const [clients, setClients] = useState({});

  const fieldsConfig = [
    { 
      key: "uuid", 
      label: "Placeholder", 
      type: "text", 
      displayForm: false,
      displayList: false
    },
    {
      key: "internal_number",
      label: "Código interno",
      type: "navigation",
      navTo: "machines",
      displayForm: false,
      displayList: true
    },
    { 
      key: "external_number", 
      label: "Código externo", 
      type: "text", 
      required: true ,
      displayForm: true,
      displayList: true
    },
    {
      key: "characteristic_batch_number",
      label: "Nº placa caracteristica",
      type: "text",
      required: true,
      displayForm: true,
      displayList: false
    },
    { 
      key: "client_name", 
      label: "Cliente", 
      type: "select", 
      options: clients, 
      required: true,
      displayForm: true,
      displayList: true
    },
    { 
      key: "owner_name", 
      label: "Dueño", 
      type: "select", 
      options: clients, 
      required: true ,
      displayForm: true,
      displayList: true
    },
    {
      key: "machine_type",
      label: "Tipo de maquina",
      type: "select",
      options: machineTypes,
      required: true,
      displayForm: true,
      displayList: true
    },
    {
      key: "machine_type_characteristic",
      label: "Placeholder",
      type: "select",
      options: machineTypeCharacteristics,
      depends: "machine_type",
      uses: machineCharacteristics,
      usesKey: "characteristic",
      displayForm: true,
      displayList: false
    },
    {
      key: "machine_brand",
      label: "Marca",
      type: "select",
      options: machineBrands,
      required: true,
      displayForm: true,
      displayList: true
    }
  ];

  const extraFieldInstances = [
    {
      instance: "machine_characteristic_values",
      needs: "machine",
      creates: "characteristic",
      fieldKey: "value",
    }
  ];

  const fetchFormInfo = async () => {
    setIsLoading(true);
    
    try {
      // Use fetchWithCache for each data type
      const tempMachineTypes = await fetchWithCache('machineTypes', 
        () => getBackend("machine_types"));
      
      const tempMachineBrands = await fetchWithCache('machineBrands', 
        () => getBackend("machine_brands"));
      
      const tempMachineTypeCharacteristics = await fetchWithCache('machineTypeCharacteristics', 
        () => getBackend("machine_type_characteristics"));
      
      const tempCharacteristics = await fetchWithCache('machineCharacteristics', 
        () => getBackend("machine_characteristics"));
      
      const tempClients = await fetchWithCache('clients', 
        () => getBackend("clients"));
      
      // Process the data as before
      setMachineTypes(
        Object.fromEntries(
          tempMachineTypes.map((item) => [
            item.uuid,
            `${item.type} ${item.subtype} ${item.subsubtype}`,
          ])
        )
      );
      
      setMachineBrands(
        Object.fromEntries(
          tempMachineBrands.map((item) => [item.uuid, item.brand])
        )
      );
      
      setClients(
        Object.fromEntries(tempClients.map((item) => [item.uuid, item.name]))
      );
      
      setMachineTypeCharacteristics(tempMachineTypeCharacteristics);
      setMachineCharacteristics(tempCharacteristics);
    } catch (error) {
      console.error("Error fetching form data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFormInfo();
  }, []);

  return (
    <Container maxWidth={false} disableGutters>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          marginBottom: "3%",
        }}
      >
        <Typography variant="h5" noWrap component="div">
          Maquinas
        </Typography>
      </Box>
      {!isLoading ? (
        <ItemList
          fields={fieldsConfig}
          tableName="machines"
          extraFieldInstances={extraFieldInstances}
          hasCheckbox={false}
          objectName={"machine"}
          canEdit={false}
          routeAfterCreate={true}
          tabledescription={"Maquinas"}
        />
      ) : (
        <CircularProgress />
      )}
    </Container>
  );
};

export default Machines;
